<template>
    <div>
        <div>
            <div class="d-flex justify-space-between mb-8">
                <div>
                    <h2 class="font-weight-medium">تصحيح إجابات "{{exam.data.name}}"</h2>
                </div>
                <div>
                    <v-btn depressed color="primary" :to="{name: 'exam', params: {id: exam.data.id}}">
                        <span>عودة للامتحان</span>
                        <v-icon right>mdi-chevron-left</v-icon>
                    </v-btn>
                </div>
            </div>
            <transition-group v-if="attemptsData && attemptsData.length" name="scroll-x-reverse-transition" mode="out-in" appear>
                <v-card v-for="attempt in attemptsData" :key="attempt.id" class="soft-shadow py-1 px-2 mb-4">
                    <v-card-text>
                        <answer-attempt :attempt="attempt" @done="deleteItem(attempt.id)" />
                    </v-card-text>
                </v-card>
            </transition-group>
            <div v-else>
                <div class="mt-4" v-if="attempts.links.next">
                    <v-btn block color="primary" depressed @click="reloadPage">عرض المزيد من الإجابات</v-btn>
                </div>
                <v-alert v-else type="info" text color="blue-grey">
                    <div class="strong-text--text medium-text">لا يوجد إجابات تحتاج للتصحيح اليدوي</div>
                </v-alert>
            </div>
        </div>
    </div>
</template>

<script>

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import AnswerAttempt from './answer-attempt.vue'

export default {
    components: {
        AnswerAttempt
    },
    props: {
        attempts: {},
        exam: {},
    },
    data() {
        return {
            loading: false,
            attemptsData: null,
        }
    },
    computed: {
        ...GlobalComputed,
    },
    methods: {
        ...GlobalMethods,
        reloadPage(){
            window.location.reload();
        },
        deleteItem(id){
            this.attemptsData = this.attemptsData.filter(item=>{
                return item.id !== id;
            })
        },
    },
    created(){
        this.attemptsData = this.attempts.data;

    },
    mounted(){

    }
}

</script>
